import repository from '@/repositories/repository'

export default baseUrl => {

    baseUrl = `${baseUrl}/parametrizacao`

    const headers = { responseType: "arraybuffer" }

    return {
        exameComposicao(id)
        {

            return repository.get(`${baseUrl}/exame-composicao/${id}`, headers)
        },
    }
}